<template>
  <div>
    <h1 class="message">
      Cookies are blocked or not supported by your browser. <br/>
      This survey does not collect any cookies,
      but requires the option to block cookies to be turned off to function properly.
    </h1>
    <div class="container-middle">
      <a v-bind:href="previousLink">
        <button class="button-reload"></button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'previousLink'
  ]
}
</script>

<style>
.container-middle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 70vh;
}
.container-middle .button-reload {
  background-image: url("/img/next-btn.svg");
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  width: 6rem;
  height: 6rem;
  border: 0;
  margin: 0 2%;
  padding: 0;
  outline: none;
  cursor: pointer;
}
</style>
